<div class="wrapper">

  <section id="banner-hoteis" class="banner-container hero is-medium banner-header-hotel top-area" aria-label="Montreal Viagens - Vila Galé Cumbuco - CE">
    <div class="hero-body bg-hoteis-destinos">
      <div class="container">
        <div class="area-breadcrumb">
          <nav class="breadcrumb">
            <ul>
              <li><a href="/"><strong>Home</strong></a></li>
              <span><i class="fas fa-chevron-right"></i></span>
              <li>Hotéis</li>
            </ul>
          </nav>
        </div>
        <h1 class="title has-text-white">Encontre os melhores <br *ngIf="!isMobile">hotéis na montreal</h1>
        <app-busca-hoteis></app-busca-hoteis>
      </div>
    </div>
    <small class="has-text-white" style="text-align: end; padding-right: 14%;">Vila Galé <br>Cumbuco  - CE</small>
  </section>

  <app-categorias-hoteis [page]="'hoteis'"></app-categorias-hoteis>

  <section id="destinos">
    <div class="container is-fluid">
      <h3 class="title">Top Destinos</h3>
      <p>Já sabe o destino da sua próxima viagem?
        <br>Confira os lugares mais populares dos nossos clientes!</p>

      <div class="itens-destinos">
        <div class="tile is-ancestor">
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis?.destinos[0].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis?.destinos[0].alt">
                  <a (click)="irParaDestino(resultHoteis?.destinos[0].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis?.destinos[0].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis?.destinos[0].estado}}</p>
                      {{resultHoteis?.destinos[0].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis?.destinos[10].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis?.destinos[10].alt">
                  <a (click)="irParaDestino(resultHoteis?.destinos[10].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis?.destinos[10].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis?.destinos[10].estado}}</p>
                      {{resultHoteis?.destinos[10].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis?.destinos[1].imagem +')'" [attr.aria-label]="resultHoteis?.destinos[1].alt">
                  <a (click)="irParaDestino(resultHoteis?.destinos[1].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis?.destinos[1].titulo}}</p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis?.destinos[1].estado}}</p>
                      {{resultHoteis?.destinos[1].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis?.destinos[2].imagem +')'" [attr.aria-label]="resultHoteis?.destinos[2].alt">
                  <a (click)="irParaDestino(resultHoteis?.destinos[2].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis?.destinos[2].titulo}}</p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis?.destinos[2].estado}}</p>
                      {{resultHoteis?.destinos[2].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
          <div class="tile is-parent is-3">
            <article class="tile is-child notification is-success"
              [style.backgroundImage]="'url('+ resultHoteis?.destinos[3].imagem +')'" style="background-size: cover;" [attr.aria-label]="resultHoteis?.destinos[3].alt">
              <a (click)="irParaDestino(resultHoteis?.destinos[3].slug)">
                <div class="img-overlay"></div>
                <div class="footer">
                  <p class="title">{{resultHoteis?.destinos[3].titulo}}</p>
                  <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis?.destinos[3].estado}}</p>
                  {{resultHoteis?.destinos[3].resumo}}
                </div>
              </a>
            </article>
          </div>
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis?.destinos[4].imagem +')'" [attr.aria-label]="resultHoteis?.destinos[4].alt">
                  <a (click)="irParaDestino(resultHoteis?.destinos[4].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis?.destinos[4].titulo}}</p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis?.destinos[4].estado}}</p>
                      {{resultHoteis?.destinos[4].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis?.destinos[5].imagem +')'" [attr.aria-label]="resultHoteis?.destinos[5].alt">
                  <a (click)="irParaDestino(resultHoteis?.destinos[5].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis?.destinos[5].titulo}}</p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis?.destinos[5].estado}}</p>
                      {{resultHoteis?.destinos[5].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>


  <app-tabela-diarias-facilita></app-tabela-diarias-facilita>

  <app-footer></app-footer>
</div>
